// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"cb6ecada","163":"1ab2bee7","419":"bc04deec","601":"3474ead8","787":"0ca21364"}[chunkId] + ".chunk.js";
};